module.exports = __webpack_public_path__ + "static/p12_B_becerroCabeza-f97b1cdac04dbcc3bf8e5778598bbfd1.png";